import { Component, OnInit } from '@angular/core';
import {BackendService} from "../../../../../common";

@Component({
  selector: 'loading-indicator',
  standalone: false,
  templateUrl: './loading-indicator.html',
  styleUrls: ['./loading-indicator.scss']
})

export class LoadingIndicator implements OnInit {

  constructor(private backendService: BackendService) { }

  ngOnInit(): void {
  }

  getLogoPath() {
    return this.backendService.asset_base + '/assets/logo.png';
  }
}
